import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LoadingScreen } from '../LoadingScreen';
import { RoutesManagerDashboard } from './RoutesManagerDashboard';
import { RoutesManagerPublic } from './RoutesManagerPublic';

export function RoutesManager(): React.JSX.Element {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <BrowserRouter>
        <Routes>
          <Route path="/dashboard/*" element={<RoutesManagerDashboard />} />
          <Route path="/*" element={<RoutesManagerPublic />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}
